import 'vue-multiselect/dist/vue-multiselect.min.css';
import ILanding from '@/interfaces/ILanding';
import { Switch as cSwitch } from '@coreui/vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import cloneObject from "@/libs/cloneObject";
import Loader from '@/components/Includes/Loader/Loader.vue';
import AttributesForm from "./AttributesForm/AttributesForm.vue";
import Multiselect from 'vue-multiselect';

@Component({
    name: 'LandingForm',
    components: {
        AttributesForm,
        cSwitch,
        Loader,
        Multiselect
    }
})
export default class LandingForm extends Vue {
    @Prop(Object) private landingData!: ILanding;
    @Prop(Boolean) private isEdit!: boolean;

    private activeTabIndex: number = 0;

    private newAttributesConstructor: { groupName: string, content: string} = {
        groupName: 'subscription',
        content: '',
    };

    private get form():ILanding {
        return this.landingData;
    }

    private get attributes() {
        return this.landingData.attributes;
    }

    private get isCreateForm() {
        return this.$route.name === 'landing_create';
    }

    private get btnText() {
        return this.isCreateForm ? 'Create' : 'Update';
    }

    private sendForm() {
        const formData = {
            id: this.form.id,
            appLandingId: this.form.appLandingId,
            title: this.form.title,
            showAcceptPrivacy: this.form.showAcceptPrivacy,
            attributes: this.attributes
        };

        if (this.isCreateForm) {
            formData.attributes = this.normalizeData(formData);
            this.$emit('createLanding', formData);
        } else {
            formData.attributes = this.normalizeData(formData, 'update');
            this.$emit('updateLanding', formData);
        }
    }

    private normalizeData(data:ILanding, action:string = 'create') {
        return cloneObject(data).attributes
            .filter((attr: {id: number, groupName: string, content: string}) => attr.content.length)
            .map((attr: {id: number, groupName: string, content: string}) => {
                if (action === 'create' || !attr.id) {
                    return {
                        groupName: attr.groupName,
                        content: attr.content
                    }
                } else {
                    return  {
                        '@id': `/api/vpn/landing_attributes/${attr.id}`,
                        groupName: attr.groupName,
                        content: attr.content
                    }
                }
            })
    }


    private cancelForm() {
        this.$router.go(-1);
    }
}
